import { StatisticGroup } from './StatisticGroup';
import { useAdminDashboardOrgDetail } from './useAdminDashboard';
import { useStoreState } from '../../reducers';
import { formatBytes, formatNumber } from '../../utils/misc';

export default function AdminOrgSummary({ orgId }: { orgId: number }) {
  const { orgPage, orgPageSize } = useStoreState(
    (storeState) => storeState.adminDashboard
  );

  const { data: orgDetail, isLoading: orgDetailLoading } =
    useAdminDashboardOrgDetail(orgId, orgPage + 1, orgPageSize);

  return (
    <StatisticGroup
      title={orgDetail?.organization_name || ''}
      stats={[
        {
          label: 'Total Users',
          value: formatNumber(orgDetail?.total_users),
          loading: orgDetailLoading,
        },
        {
          label: 'Storage Limit',
          value:
            orgDetail?.allowed_space === -1
              ? 'Unlimited'
              : formatBytes(orgDetail?.allowed_space),
          loading: orgDetailLoading,
        },
        {
          label: 'Storage Usage',
          value: formatBytes(orgDetail?.space_used),
          loading: orgDetailLoading,
        },
        {
          label: 'Upload Limit',
          value: formatBytes(orgDetail?.upload_limit),
          loading: orgDetailLoading,
        },
      ]}
      data-testid="admin-org-summary-group"
    />
  );
}
